import { Shimmer } from '@components';

import { Container, Content, Heading } from './Updates.styles';

const ItemLoading = () => {
  return (
    <Shimmer
      style={{ height: 52, width: '100%', borderRadius: 8, marginTop: 12 }}
      primary="#f1f1f1"
      secondary="#ececec"
    />
  );
};

const TableContentLoading = () => {
  return (
    <Content>
      <ItemLoading />
      <ItemLoading />
      <ItemLoading />
      <ItemLoading />
      <ItemLoading />
    </Content>
  );
};

const TableLoading = () => {
  return (
    <>
      <Heading>
        <Shimmer
          style={{ height: 12, width: 70, borderRadius: 4 }}
          primary="#f1f1f1"
          secondary="#ececec"
        />
        <Shimmer
          style={{ height: 12, width: 70, borderRadius: 4 }}
          primary="#f1f1f1"
          secondary="#ececec"
        />
        {/* <Shimmer
          style={{ height: 12, width: 120, borderRadius: 4 }}
          primary="#f1f1f1"
          secondary="#ececec"
        /> */}
        <div />
        <Shimmer
          style={{ height: 12, width: 70, borderRadius: 4 }}
          primary="#f1f1f1"
          secondary="#ececec"
        />
        <Shimmer
          style={{ height: 12, width: 70, borderRadius: 4 }}
          primary="#f1f1f1"
          secondary="#ececec"
        />
      </Heading>

      <TableContentLoading />
    </>
  );
};

const UpdatesLoading = () => {
  return (
    <Container>
      <TableLoading />
    </Container>
  );
};

export { UpdatesLoading, TableLoading, TableContentLoading };
